import abdulrahman from './abdulrahman.jpg';
import yaman from './yaman.png';
import hytham from './hytham.jpg';

export {
    abdulrahman,
    yaman,
    hytham,
}


// WEBPACK FOOTER //
// ./src/assets/images/team/index.js